import PageLayout from '@/pages/Index'
import PageLoginLayout from '@/pages/LoginLayout'

export const adminRoute = [
  {
    path: '/admin',
    component: PageLayout,
    meta: { requiresAuth: false, roles: ['admin'] },
    children: [
      {
        name: 'Admin',
        path: 'dashboard',
        meta: { title: 'Admin', requiresAuth: true, roles: ['admin'] },
        component: () => import('@/pages/admin/Admin'),
      },
      {
        name: 'User',
        path: 'user',
        meta: { title: 'User', requiresAuth: true, roles: ['admin'] },
        component: () => import('@/pages/admin/User'),
      },
      {
        name: 'Device',
        path: 'device',
        meta: { title: 'Device', requiresAuth: true, roles: ['admin'] },
        component: () => import('@/pages/admin/Device'),
      },
      {
        name: 'DeviceRegister',
        path: 'deviceregister',
        meta: { title: 'DeviceRegister', requiresAuth: true, roles: ['admin'] },
        component: () => import('@/pages/admin/DeviceRegister'),
      },
    ]
  }
]

export const authenRoute = [
  {
    path: '/',
    component: PageLayout,
    meta: { requiresAuth: false, roles: ['user', 'admin'] },
    children: [
      {
        name: 'DashboardMenu',
        path: '',
        meta: { title: 'Dashboard Menu', requiresAuth: true, roles: ['user', 'admin'] },
        component: () => import('@/pages/LandingPage'),
      },
      {
        name: 'DashboardMenuAdmin',
        path: 'menu/:id',
        meta: { title: 'Dashboard Menu', requiresAuth: true, roles: ['user', 'admin'] },
        component: () => import('@/pages/LandingPage'),
      },
      {
        name: 'Farm',
        path: 'farm',
        meta: { title: 'Farm', requiresAuth: true, roles: ['user', 'admin'] },
        component: () => import('@/pages/Farm'),
      },
      {
        name: 'FarmAdmin',
        path: 'admin/farm/:id',
        meta: { title: 'FarmAdmin', requiresAuth: true, roles: ['user', 'admin'] },
        component: () => import('@/pages/Farm'),
      },
      {
        name: 'IoExtension',
        path: 'io/extension/:id',
        meta: { title: 'IoExtension', requiresAuth: true, roles: ['user', 'admin'] },
        component: () => import('@/pages/IoExtension'),
      },
      {
        name: 'ModbusSensor',
        path: 'modbus/sensor/:id',
        meta: { title: 'FarmAdmin', requiresAuth: true, roles: ['user', 'admin'] },
        component: () => import('@/pages/ModbusSensor'),
      },
      {
        name: 'Overload',
        path: 'overload/:id',
        meta: { title: 'Overload', requiresAuth: true, roles: ['user', 'admin'] },
        component: () => import('@/pages/DeviceOverload'),
      },
      {
        name: 'ModbusSwitch',
        path: 'modbus/switch/:id',
        meta: { title: 'FarmAdmin', requiresAuth: true, roles: ['user', 'admin'] },
        component: () => import('@/pages/ModbusSwitch'),
      },
      {
        name: 'Gateway',
        path: 'device/gateway/:id',
        meta: { title: 'Gateway', requiresAuth: true, roles: ['user', 'admin'] },
        component: () => import('@/pages/EspNowGateway'),
      },
      {
        name: 'FarmUser',
        path: 'farm/user/:id',
        meta: { title: 'Farm User', requiresAuth: true, roles: ['user', 'admin'] },
        component: () => import('@/pages/FarmUser'),
      },
      {
        name: 'Dashboard',
        path: 'dashboard/:id',
        meta: { title: 'Dashboard', requiresAuth: true, roles: ['user'] },
        component: () => import('@/pages/Dashboard'),
      },
      {
        name: 'ControlDevice',
        path: 'control/:id',
        meta: { title: 'ControlDevice', requiresAuth: true, roles: ['user'] },
        component: () => import('@/pages/ControlDevice'), 
      },
      {
        name: 'DashboardList',
        path: 'dashboards/list',
        meta: { title: 'DashboardList', requiresAuth: true, roles: ['user'] },
        component: () => import('@/pages/dashboards/DashboardList'),
      },
      {
        name: 'DashboardEditor',
        path: 'dashboards/editor/:id',
        meta: { title: 'DashboardEditor', requiresAuth: true, roles: ['user'] },
        component: () => import('@/pages/dashboards/DashboardEditor'),
      },
      {
        name: 'DashboarView',
        path: 'dashboards/view/:id',
        meta: { title: 'DashboardEditor', requiresAuth: true, roles: ['user'] },
        //component: () => import('@/pages/dashboards/TestResponsive'),
        component: () => import('@/pages/dashboards/DashboardView'),

      },
    ],
  },
]

export const publicRoute = [
  {
    path: '/authen',
    component: PageLoginLayout,
    children: [
      {
        name: 'Login',
        path: 'login',
        meta: { requiresAuth: false },
        component: () => import('@/pages/Login2'),
      },
      {
        name: 'Signup',
        path: 'signup',
        meta: { requiresAuth: false },
        component: () => import('@/pages/Signup'),
      },
      {
        name: 'Unauthorized',
        path: 'unauthorized',
        meta: { requiresAuth: false },
        component: () => import('@/pages/Unauthorized'),
      },
      {
        name: 'Privacy',
        path: 'privacy',
        meta: { requiresAuth: false },
        component: () => import('@/pages/Privacy'),
      },
    ]
  }
]

